import { render, staticRenderFns } from "./EditSubjectDialog.vue?vue&type=template&id=fad3abdc"
import script from "@/components/curriculum/EditSubjectDialog.ts?vue&type=script&lang=ts&external"
export * from "@/components/curriculum/EditSubjectDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/curriculum/edit-subject-dialog.scss?vue&type=style&index=0&prod&lang=scss&scoepd=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports